import { COLUMN_BUILDING, COLUMN_DEVICE, COLUMN_INPUTS_COUNT, COLUMN_LEVEL, COLUMN_NAME, COLUMN_SITE } from "../../constants/column-types";
import { FILTER_SITES, FILTER_BUILDINGS } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const FloorColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        sortByName: "floorName",
        sortDirection: "asc",
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Building",
        accessor: "building",
        isNumeric: false,
        id: 1,
        active: true,
        sortByName: "building.buildingName",
        sortDirection: "asc",
        searchOnName: "building.id",
        lookupName: "building.buildingName",
        translationKey: "building",
        filterId: FILTER_BUILDINGS,
        settingDataName: 'building',
        columnId: COLUMN_BUILDING,
    },
    {
        heading: "Level",
        accessor: "level",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "level",
        columnId: COLUMN_LEVEL,
    },
    {
        heading: "I/O Device",
        accessor: "deviceName",
        isNumeric: true,
        id: 3,
        active: true,
        translationKey: "ioDevice",
        columnId: COLUMN_DEVICE,
    },
    {
        heading: "Relay",
        accessor: "actionName",
        isNumeric: true,
        id: 4,
        active: true,
        translationKey: "relay"
    },
    // {
    //     heading: "Inputs",
    //     accessor: "inputs",
    //     isNumeric: true,
    //     id: 3,
    //     active: true,
    //     translationKey: "inputs",
    //     columnId: COLUMN_INPUTS_COUNT,
    // },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 5,
        active: true,
        sortByName: "building.site.siteName",
        sortDirection: "asc",
        searchOnName: "building.site.id",
        lookupName: "building.site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    },
    // {
    //     heading: "Relays",
    //     accessor: "relays",
    //     isNumeric: true,
    //     id: 5,
    //     active: true,
    //     translationKey: "relays",
    //     columnId: COLUMN_RELAYS_COUNT,
    // }
];

export default FloorColumns;
